import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import ContactTypeEditor from "../../editors/customer/contactType";

const ContactTypes: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.ContactTypesList}
			endpoint={Endpoint.ContactTypes}
			addScreen={{ screen: ContactTypeEditor, isAllowed: hasPermission(Permission.ContactTypesAdd) }}
			editScreen={{ screen: ContactTypeEditor, isAllowed: hasPermission(Permission.ContactTypesUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.ContactTypesDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default ContactTypes;
